import { render, staticRenderFns } from "./LabelHandle.vue?vue&type=template&id=6cbe0122&scoped=true"
import script from "./LabelHandle.vue?vue&type=script&lang=ts"
export * from "./LabelHandle.vue?vue&type=script&lang=ts"
import style0 from "./LabelHandle.vue?vue&type=style&index=0&id=6cbe0122&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbe0122",
  null
  
)

export default component.exports